export const BG_VIDEO =
  "https://cdn.queen.one/connect/ui/bg_video_compressed.mp4" as const;
export const BG_AUDIO =
  "https://cdn.queen.one/connect/ui/bg_audio_compressed.mp3" as const;

export const labelStyles = {
  fontFamily: "Lust, sans-serif",
  fontSize: "18px",
  fontWeight: 400,
  color: "#fff",
};

export const authLinkStyles = {
  color: "#fff",
  fontFamily: "Lust, sans-serif",
  fontSize: "20px",
  textAlign: "center",
  textDecoration: "underline",
};

export const sxTextFieldStyles = {
  "& .MuiOutlinedInput-root": {
    background: "#fff",
    borderRadius: "10px",
    height: "60px",
    fontSize: "20px",
    fontWeight: 300,
  },
  "& .MuiInputBase-input": {
    color: "#252327",
    "&::placeholder": {
      color: "#252327",
      opacity: 0.7,
    },
  },
};
